import { __API_BASE_URL__, __FILE_SERVER_URL__ } from "@/shared/config";

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const deriveFileServerUrl = (apiServerUrl: string): string => {
    try {
        const url = new URL(apiServerUrl);
        if (!/^app(?:\.|-)/.test(url.hostname)) return "";

        url.hostname = url.hostname.replace(/^app(?=\.|-)/, "file");
        url.pathname = "";
        url.search = "";
        url.hash = "";

        return trimTrailingSlash(url.toString());
    } catch {
        return "";
    }
};

const fileServerUrl = trimTrailingSlash(
    __FILE_SERVER_URL__ || deriveFileServerUrl(__API_BASE_URL__),
);

export const getFileUrl = (fileName?: string): string => {
    if (!fileName || fileName.includes("undefined")) return "";
    if (/^https?:\/\//i.test(fileName)) return fileName;
    if (!fileServerUrl) return "";

    return `${fileServerUrl}/${fileName.replace(/^\/+/, "")}`;
};
